import { StateCreator } from 'zustand';
import { AppState } from '../types';

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// SLICE DEFINITION
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

type UiSliceType = Pick<AppState,
    | 'isInitialized'
    | 'showFormulas'
    | 'zoomLevel'
    | 'kalkulatorFilters'
    | 'isSystemBooted'
    | 'setShowFormulas'
    | 'setZoomLevel'
    | 'setKalkulatorFilters'
    | 'setSystemBooted'
>;

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// SLICE CREATOR
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

export const createUiSlice: StateCreator<AppState, [], [], UiSliceType> = (set) => ({
    // isInitialized wird jetzt EXKLUSIV von der dataSlice.ts auf true gesetzt, 
    // sobald Firebase die Daten erfolgreich geliefert hat.
    isInitialized: false,
    showFormulas: false,
    zoomLevel: 100,
    
    // System Boot State (Bootet bei F5)
    isSystemBooted: false, 

    kalkulatorFilters: {
        activeMaterialIds: [],
        activeDeviceIds: []
    },

    // 💉 CHIRURGIE-FIX: Die schädliche initializeStore-Funktion wurde komplett entfernt!
    // Die App nutzt nun zwingend die echte Funktion aus dataSlice.ts, die mit Firebase spricht.

    setShowFormulas: (show) => set((state) => ({ showFormulas: typeof show === 'function' ? show(state.showFormulas) : show })),
    
    setZoomLevel: (level) => set((state) => ({ zoomLevel: typeof level === 'function' ? level(state.zoomLevel) : level })),

    setKalkulatorFilters: (filters) => set((state) => ({
        kalkulatorFilters: { ...state.kalkulatorFilters, ...filters }
    })),

    setSystemBooted: () => set({ isSystemBooted: true })
});